export default {
	setCareers(state, careers) {
		state.careers = careers
	},
	setSelectedCareer(state, career) {
		state.selected_career = career
	},
}
